import {EditorView} from "@codemirror/view";
import UiStore from "../../../state/uiStore";
export type ThemeOptions = {
	dark?: boolean;
};

export const createCodeMirrorTheme = (uiStore: UiStore) => {
	const fontSize = uiStore.editorFontSize + "rem"; // handle font size changing

	// see https://codemirror.net/examples/styling/
	return EditorView.theme({
		"&": {
			fontSize,
			backgroundColor: "white",
			width: "100%",
			height: "100%",
		},
		// gutters
		".cm-gutters": {
			backgroundColor: "var(--cm-gutters-background-color)",
			borderColor: "var(--cm-gutters-border-color)",
		},
		".cm-gutter.cm-lineNumbers .cm-gutterElement": {
			color: "var(--cm-linenumbers-gutterelement-color)",
			paddingLeft: "2rem",
		},
		".cm-gutter.cm-foldGutter .cm-gutterElement": {
			padding: "0 0.5rem",
		},
		".cm-gutter .cm-gutterElement.cm-activeLineGutter": {
			color: "black",
		},

		// content
		".cm-line, .cm-gutterElement": {
			sizing: "border-box",
			paddingTop: "1px",
			paddingBottom: "1px",
		},
		".cm-content": {
			// To make room for the test results toast
			paddingBottom: "4rem",
		},
		// active line
		".cm-activeLine.cm-line, .cm-activeLineGutter.cm-gutterElement": {
			// 1px top/bottom padding gets replaced by top/bottom borders on the active line
			borderTop: "1px solid var(--cm-activeline-border-color)",
			borderBottom: "1px solid var(--cm-activeline-border-color)",
			paddingTop: 0,
			paddingBottom: 0,
		},
	});
};
